<template>
  <button
    :disabled="!activeStepIsComplete || changingStep"
    @click="onClick"
  ><slot>{{ lastStepIsActive ? 'Finish' : 'Next'}}</slot></button>
</template>

<script>
import {
  mapInstanceActions as mapActions,
  mapInstanceGetters as mapGetters,
  mapInstanceState as mapState
} from '@urbn/vuex-helpers';
import { STORE_NAMESPACE_KEY, WIZARD } from './const';
import { NEXT_STEP } from '../../store/modules/formWizard/actions';
import { ACTIVE_STEP_IS_COMPLETE, LAST_STEP_IS_ACTIVE } from '../../store/modules/formWizard/getters';
import { IS_TRANSITIONING } from '../../store/modules/formWizard/state';

export default {
  inject: [STORE_NAMESPACE_KEY, WIZARD],

  data: () => ({
    changingStep: false
  }),

  computed: {
    ...mapGetters((vm) => vm[STORE_NAMESPACE_KEY], {
      activeStepIsComplete: ACTIVE_STEP_IS_COMPLETE,
      lastStepIsActive: LAST_STEP_IS_ACTIVE
    }),

    ...mapState((vm) => vm[STORE_NAMESPACE_KEY], [
      IS_TRANSITIONING
    ])
  },

  methods: {
    ...mapActions((vm) => vm[STORE_NAMESPACE_KEY], {
      nextStep: NEXT_STEP
    }),

    onClick() {
      if (this.lastStepIsActive) {
        this[WIZARD].$emit('finish');
      } else {
        this.changingStep = true;
        this.nextStep();
      }
    }
  },

  watch: {
    [IS_TRANSITIONING](val) {
      if (!val) this.changingStep = false;
    }
  }
};
</script>
